<template>

	<div class="container main-content">	
		<div class="row mb-5">
			<div class="col-12 col-md-8 offset-md-2 text-center">
				<h4 class="dark-highlight mb-5">Verify your email address</h4>
				<p class="mb-3 info-text">We've sent you a one-time code to <strong>{{ bi.emailAddress }}</strong>.  It may take a few minutes to arrive.  Please do not close this browser while you wait.  Code will be valid for 10 minutes.</p>
				<p class="mb-5 info-text"><small><i>If you do not receive the verification code within a few minutes, please check your Spam folder.</i></small></p>
				<input class="bitaddress form-control no-border-radius inline" 
					placeholder="6-digit verification code" 
					:disabled="isProcessing"
					type="number" pattern="[0-9]*" inputmode="numeric"
					ref="mobileCode" required v-model="in_mobileCode" v-bind:class="{'is-invalid': hasError}">
				<small class="error" v-if="hasError">{{ errorMessage }}</small>
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-12 text-center">
				<small v-if="!isProcessingResend" class="col-6 text-center text-secondary"><a :class="{'disabled' : isProcessing }" href="" v-on:click.prevent="resendCode">Resend Code</a></small>
				<small v-if="isProcessingResend">Resending... <i class="fas fa-circle-notch fa-spin"></i></small>
			</div>
		</div>
		<div class="row">
			<div class="col-12 text-center">
				<a href="#" id="mobile-verification-next" class="btn next-btn" v-on:click.prevent="verifyMobileCode" v-if="!isProcessing">NEXT</a>
				<a href="#" class="btn next-btn disabled" v-on:click.prevent="noop" v-if="isProcessing">PLEASE WAIT... <i class="fas fa-circle-notch fa-spin"></i></a>
			</div>
		</div>

		<cc-modal v-if="showModal" v-bind:confirm="false" @action="modalAction" no="Close">
			<p slot="body">{{ modalMessage }}</p>
		</cc-modal>
	</div>


</template>

<script>

import { eventBus } from './../main'

export default {
	mounted() {
		this.$refs.mobileCode.focus();
	},
	data() {
		return {
			in_mobileCode: '',
			bi: this.$gstate.getBuyerInfo(),
			hasError: false,
			errorMessage: '',
			isProcessing: false,
			isProcessingResend: false,
			codeResent: false,
			showModal: false,
			modalMessage: "",
		}
	},
	created(){
		eventBus.$on('nextScreen', this.verifyMobileCode);
	},
	beforeDestroy(){
		eventBus.$off('nextScreen', this.verifyMobileCode);
	},
	methods: {
		verifyMobileCode: function() {
			this.hasError = false;

			if (!this.in_mobileCode) {
				this.hasError = true;
				this.errorMessage = 'Please enter code sent to your email.'
			}
			if (isNaN(this.in_mobileCode)) {
				this.hasError = true;
				this.errorMessage = "Invalid code.  Code must be numeric.";
			}
			if (this.hasError) {
				return;
			}

			this.isProcessing = true;

			this.$gstate.log("verifying mobile code")

			// save code for later use
			this.$gstate.saveMobileCode(this.in_mobileCode);

			var urlstr = this.$gstate.getApiBaseURL() + '/mobileverification';
			this.axios.post(urlstr, {
				refId : this.$gstate.getRefId(),
				verificationCode : this.in_mobileCode
			}, this.$gstate.getAxiosHeaders())
				.then(response => {

					this.isProcessing = false;
					this.$gstate.saveFlowStateAndProceed(response.data, this);
					
				})
				.catch(error => {

					this.$gstate.log(error.response);

					this.isProcessing = false;
					this.hasError = true;
					this.errorMessage = error.response.data.error.msg;

					if(error.response.data.error.code == "VOICECLIP.MISSING"){

						if(this.$gstate.getPaymentMethod() == 'FLEXEPIN'){
							this.$router.push('audio-input-skip');
						} else {
							this.$router.push('audio-input');
						}

					} else if(error.response.data.error.code == "SELFIEIMG.MISSING"){

						this.$router.push('image-input-choice');

					} else if(error.response.data.error.code == "MOBILE.INVALIDATTEMPT.REACHED" || error.response.data.error.code == "TRANSACTION.NOTFOUND"){
						
						this.errorMessage += ".  Transaction has been cancelled.  Redirecting to homepage in 5 seconds..."
						
						this.$emit('setLeaveNotification', false);
						this.$gstate.redirectHome(100, 5000, this.errorMessage);

					}

				});

		},
		resendCode: function() {

			this.isProcessingResend = true;
			var urlstr = this.$gstate.getApiBaseURL() + '/generatesmscode';
			
			this.$gstate.log("resending verification code...");

			this.axios.post(urlstr, {
				refId : this.$gstate.getRefId()
			},
			this.$gstate.getAxiosHeaders())
				.then(response => {

					this.isProcessingResend = false;
					this.showModal = true;
					if(response.data.error){
						this.modalMessage = response.data.error;
					} else {
						this.modalMessage = "Verification code resent to " + this.bi.emailAddress;
					}

				})
				.catch(error => {
					this.isProcessingResend = false;
					this.hasError = true;
					this.errorMessage = error.response.data.error.msg;
				});
		},
		modalAction: function(action){
			if(action == "close"){
				this.showModal = false;
			}
		}
	}
}
</script>
